"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _InlineEdit = _interopRequireDefault(require("@cimpress/react-components/lib/InlineEdit"));

var _ruleDisplay = _interopRequireDefault(require("../shared/ruleDisplay"));

var _constraintCard = _interopRequireDefault(require("./constraintCard"));

var _messages = _interopRequireDefault(require("./messages"));

var _propTypes2 = require("../shared/propTypes");

var _keyValidators = require("../shared/validators/keyValidators");

var _constraintEditor = _interopRequireDefault(require("./constraintEditor"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ConstraintComponent = function ConstraintComponent(props) {
  var options = props.options,
      constraintRule = props.constraintRule,
      constraintRules = props.constraintRules,
      onChange = props.onChange,
      addCompleteOptionConstraint = props.addCompleteOptionConstraint,
      errorMessage = props.errorMessage;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(!(constraintRule.conditions.length && constraintRule.results.length)),
      _useState2 = _slicedToArray(_useState, 2),
      editing = _useState2[0],
      setEditing = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      nameError = _useState4[0],
      setNameError = _useState4[1];

  if (constraintRule.conditions.length === 0 && constraintRule.results.length === 0) {
    setTimeout(function () {
      return onChange(constraintRule.name, _objectSpread(_objectSpread({}, constraintRule), {}, {
        conditions: [{
          attribute: '',
          operator: undefined
        }],
        results: [{
          attribute: '',
          operator: undefined
        }]
      }));
    }, 0);
  } // TODO reattach this?


  var validateName = function validateName(newName) {
    if (!newName) {
      return formatMessage(_messages["default"].mustProvideRuleName);
    }

    return (0, _keyValidators.validateRuleName)(newName, constraintRules.filter(function (value) {
      return value !== constraintRule;
    }), 'Rule');
  };

  var onUpdateName = function onUpdateName(e) {
    var nameInvalid = validateName(e.target.value);

    if (nameInvalid) {
      setNameError(nameInvalid);
      setTimeout(function () {
        return setNameError(null);
      }, 1500);
      return;
    }

    setNameError(null);
    onChange(constraintRule.name, _objectSpread(_objectSpread({}, constraintRule), {}, {
      name: e.target.value
    }));
  };

  var onDelete = function onDelete() {
    return onChange(constraintRule.name, null);
  };

  var onEditClick = function onEditClick() {
    return setEditing(function (prevEditing) {
      return !prevEditing;
    });
  };

  var onCopy = function onCopy() {
    var newConstraint = (0, _cloneDeep["default"])(constraintRule);
    newConstraint.name = newConstraint.name + ' (copy)';
    addCompleteOptionConstraint(newConstraint);
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_constraintCard["default"], {
      title:
      /*#__PURE__*/
      _react["default"].createElement("div", null, nameError ?
      /*#__PURE__*/
      _react["default"].createElement("div", {
        "class": "text-danger"
      }, nameError) : null,
      /*#__PURE__*/
      _react["default"].createElement(_InlineEdit["default"], {
        value: constraintRule.name,
        onChange: onUpdateName,
        placeholder: formatMessage(_messages["default"].optionConstraintName)
      })),
      errorMessage: errorMessage,
      editing: editing,
      onEditClick: onEditClick,
      onDeleteClick: onDelete,
      onCopyClick: onCopy,
      content: editing ?
      /*#__PURE__*/
      _react["default"].createElement(_constraintEditor["default"], {
        rule: constraintRule,
        constraintRules: constraintRules,
        onDelete: onDelete,
        options: options,
        onChange: onChange,
        errorMessage: errorMessage
      }) :
      /*#__PURE__*/
      _react["default"].createElement("div", {
        className: "card-block"
      },
      /*#__PURE__*/
      _react["default"].createElement(_ruleDisplay["default"], {
        conditions: constraintRule.conditions,
        results: constraintRule.results
      }))
    })
  );
};

ConstraintComponent.propTypes = {
  constraintRule: _propTypes["default"].shape(_propTypes2.constraintRuleShape),
  constraintRules: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.constraintRuleShape)),
  onChange: _propTypes["default"].func.isRequired,
  errorMessage: _propTypes["default"].string
};
ConstraintComponent.defaultProps = {
  errorMessage: ''
};
var _default = ConstraintComponent;
exports["default"] = _default;